// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthLayout_mainLayoutContainer__bJ\\+kb {
  padding: 1rem;
  max-width: 1050px;
  margin: auto;
}

.AuthLayout_footerContainer__RJEyc {
  text-align: center;
  margin-top: 60px;
  color: #464748;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/component/common/layouts/auth/AuthLayout.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,iBAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AADF","sourcesContent":["@import \"../../../../assets/styles/mixin.scss\";\n\n.mainLayoutContainer {\n  padding: 1rem;\n  max-width: 1050px;\n  margin: auto;\n}\n\n.footerContainer {\n  text-align: center;\n  margin-top: 60px;\n  color: #464748;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainLayoutContainer": `AuthLayout_mainLayoutContainer__bJ+kb`,
	"footerContainer": `AuthLayout_footerContainer__RJEyc`
};
export default ___CSS_LOADER_EXPORT___;
